<ion-app>
  <ion-menu side="start" menuId="first" contentId="main">
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title color="light20">Menu</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <ion-list ngClass="background-spacer">
        <ion-menu-toggle auto-hide="true">
          <ion-item [disabled]="!isSignedIn" button [routerLink]="['/notifications']" detail>
            <ion-icon name="megaphone" slot="start"/>
            <ion-label>Notifications</ion-label>
          </ion-item>
          <ion-item [disabled]="!isSignedIn" [routerLink]="['/punches']" detail>
            <ion-icon name="hourglass" slot="start"/>
            <ion-label>Punches</ion-label>
          </ion-item>
          <ion-item [disabled]="!isSignedIn" [routerLink]="['/time-sheets']" detail>
            <ion-icon name="timer" slot="start"/>
            <ion-label>Timesheets</ion-label>
          </ion-item>
          <ion-item *ngIf="!isSignedIn && isAppMode" (click)="removeStorage()" detail>
            <ion-icon name="server-outline" slot="start"/>
            <ion-label>Remove Storage</ion-label>
          </ion-item>
          <ion-item *ngIf="isSignedIn && !isAppMode" (click)="setUserPin()" detail>
            <ion-icon name="key-outline" slot="start"/>
            <ion-label>Set User PIN</ion-label>
          </ion-item>
          <ion-item [routerLink]="['/user-config']" detail>
            <ion-icon name="settings" slot="start"/>
            <ion-label>Configuration</ion-label>
          </ion-item>
          <app-sign-in-out [parent]="'menu'"/>
        </ion-menu-toggle>
      </ion-list>
    </ion-content>
  </ion-menu>
  <ion-router-outlet id="main"/>
</ion-app>
